<ul
  class="nav  right-side-bar"
  [ngStyle]="getSidebarStyle()"
  *ngIf="isPanelPinned"
>
  <!-- C153176-4565: generate CSS classes dynamically-->
  <li
    class="py-3 w-100"
    [ngClass]="{
        'padding-btm-horizontal':inboxViewMode === 'horizontal',
        'padding-btm': inboxViewMode === 'vertical'}"
    style="margin-top: 10px"
  >
    <div
      class="nav d-flex align-items-center flex-column"
      (click)="slideOpen('docs')" id="sidePanelOpenButton" #sidePanelOpenButton
    >
      <div class="image-holder" id="sidePanelOpenButton" #sidePanelOpenButton>
        <span class="top-right" id="sidePanelOpenButton" #sidePanelOpenButton>{{attachmentList?.length}}</span>
        <img src="assets/Inbox/sideBarAttach.svg" alt="" id="sidePanelOpenButton" #sidePanelOpenButton/>
      </div>
      <div class="menu-text" id="sidePanelOpenButton" #sidePanelOpenButton>Docs</div>
    </div>
  </li>
  <li
    class="w-100"
    [ngClass]="{'padding-btm-horizontal':inboxViewMode === 'horizontal',
    'padding-btm': inboxViewMode === 'vertical'}"
  >
    <div
      class="nav d-flex align-items-center flex-column"
      (click)="slideOpen('audit')" id="sidePanelOpenButton" #sidePanelOpenButton
    >
      <div class="image-holder" id="sidePanelOpenButton" #sidePanelOpenButton>
        <img src="assets/Inbox/audit_icon_u92.svg" alt="" id="sidePanelOpenButton" #sidePanelOpenButton/>
      </div>
      <div class="menu-text" id="sidePanelOpenButton" #sidePanelOpenButton>Audit</div>
    </div>
  </li>
  <li
    class="w-100 hide-trade-lookup"
    [ngClass]="{'padding-btm-horizontal':inboxViewMode === 'horizontal', 
    'padding-btm': inboxViewMode === 'vertical'}"
  >
    <div class="nav d-flex align-items-center flex-column" (click)="openClc()">
      <div
        [ngClass]="currentTab === 'PENDING APPROVAL'?'image-holder-disabled':'image-holder'"
      >
        <img
          src="assets/Inbox/sideBarAttachTradeLookup.svg"
          style="width:27px;height:27px"
          alt="CLC"
        />
      </div>
      <div class="menu-text">
        Trade <br />
        Lookup
      </div>
    </div>
  </li>
  <li
    class="w-100"
    [ngClass]="{'padding-btm-horizontal':inboxViewMode === 'horizontal',
    'padding-btm': inboxViewMode === 'vertical'}"
  >
    <div
      class="nav d-flex align-items-center flex-column"
      (click)="slideOpen('notes')" id="sidePanelOpenButton" #sidePanelOpenButton
    >
      <div class="image-holder" id="sidePanelOpenButton" #sidePanelOpenButton>
        <span class="top-right notes-badge" id="sidePanelOpenButton" #sidePanelOpenButton>{{note?.length ?? 0}}</span>
        <img class="notes" src="assets/Inbox/sideBarNotes.svg" alt="" id="sidePanelOpenButton" #sidePanelOpenButton/>
      </div>
      <div class="menu-text" id="sidePanelOpenButton" #sidePanelOpenButton>Notes</div>
    </div>
  </li>
  <li
    class="w-100"
    [ngClass]="{'padding-btm-horizontal':inboxViewMode === 'horizontal',
    'padding-btm': inboxViewMode === 'vertical'}"
    *ngIf="!hideContactsForTaskize"
  >
    <div
      class="nav d-flex align-items-center flex-column"
      (click)="slideOpen('contacts')" id="sidePanelOpenButton" #sidePanelOpenButton
    >
      <div class="image-holder" id="sidePanelOpenButton" #sidePanelOpenButton>
        <img src="assets/Inbox/sideBarContacts.svg" alt="" id="sidePanelOpenButton" #sidePanelOpenButton />
      </div>
      <div class="menu-text" id="sidePanelOpenButton" #sidePanelOpenButton>Contacts</div>
    </div>
  </li>
  <li
    class="w-100 mt-auto"
    [ngClass]="{'padding-btm-horizontal':inboxViewMode === 'horizontal',
    'padding-btm': inboxViewMode === 'vertical'}"
  >
  <div class="divider"></div>
    <div
      class="nav d-flex align-items-center flex-column"
      (click)="onPinPanel()"
    >
      <div class="pin-holder"  pTooltip="Unpin Side Bar"
      tooltipPosition="top"
      tooltipStyleClass="leftTooltip p-tooltip-text">
        <img class="default-icon"  src="assets/Inbox/sideBarPin.svg" alt="default icon" />
        <img class="hover-icon-pin" src="assets/Inbox/sideBarPinHover.svg" alt="hover icon pin" />
      </div>
    </div>
  </li>
</ul>

<!-- Right Panel Components[Open on top Nav buttons click] -->

<!-- <p-sidebar
  [(visible)]="slideVisible"
  *ngIf="slideVisible"
  [position]="'right'"
  [modal]="false"
  [showCloseIcon]="false"
  styleClass="sideBarStyle"
  (onHide)="hideSlideBar($event)"
>
  <p-tabView
    [activeIndex]="activeIndex"
    class="pTabStyle"
    (onChange)="onTabChange($event)"
  >
    <p-tabPanel header="DOCS">
      <ng-template pTemplate="content">
        <app-attachment [attachments]="attachmentList"></app-attachment>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="AUDIT">
      <ng-template pTemplate="content">
        <app-audit-detail [audits]="audits"></app-audit-detail>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="NOTES">
      <ng-template pTemplate="content">
        <app-notes-details
          [notes]="notes"
          [selectedInquiryId]="selectedInquiryId"
          [assignedGroupName]="assignedGroupName"
          (noteAdded)="onNotesAdded($event)"
        ></app-notes-details>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel header="CONTACTS" cache="true" *ngIf="!hideContactsForTaskize">
      <ng-template pTemplate="content">
        <contact-list
          (contactEvent)="onPushContact($event)"
          [fromGroupName]="groupName"
          [topContactAdded]="topContactAdded"
        ></contact-list>
      </ng-template>
    </p-tabPanel>
    <p-tabPanel cache="true" (click)="hideSlideBar($event)">
      <ng-template pTemplate="header">
        <img [src]="'assets/Inbox/rightPanelClose.svg'" alt="Close" class="closeIcon" 
      /></ng-template>
    </p-tabPanel>
  </p-tabView>
</p-sidebar> -->
<p-dialog
  [(visible)]="displayClc"
  [modal]="true"
  [responsive]="true"
  [maximizable]="false"
  [appendTo]="'body'"
  [styleClass]="'contextMenuModal CLCclass'"
  [closable]="false"
  [dismissableMask]="true"
  [baseZIndex]="10000"
  [closeOnEscape]="true"
  [style]="{'min-height':'18em','max-height':'31em','width':'93em','top':'64px !important','margin-bottom':'16em'}"
>
  <div *ngIf="displayClc">
    <app-clc
      [clc]="clc"
      (closeClc)="closeClc($event)"
      (tradesEvent)="onSelectedTrades($event)"
    ></app-clc>
  </div>
</p-dialog>
